import axios from '../../../HttpRequests/axios';

export const FETCH_PROJECT_BREAKDOWN_REQUEST = 'FETCH_PROJECT_BREAKDOWN_REQUEST';
export const FETCH_PROJECT_BREAKDOWN_SUCCESS = 'FETCH_PROJECT_BREAKDOWN_SUCCESS';
export const FETCH_PROJECT_BREAKDOWN_FAILURE = 'FETCH_PROJECT_BREAKDOWN_FAILURE';

export default function fetchProjectBreakdown() {
  return (dispatch) => {
    dispatch({ type: FETCH_PROJECT_BREAKDOWN_REQUEST });

    return axios
      .get('/dashboard/projects/breakdown')
      .then((response) => {
        dispatch({
          type: FETCH_PROJECT_BREAKDOWN_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      })
      .catch((error) => {
        console.error('Project Breakdown Error:', error);
        dispatch({
          type: FETCH_PROJECT_BREAKDOWN_FAILURE,
          payload: error.message || 'Failed to load project breakdown',
        });
        throw error;
      });
  };
}
